import { render, staticRenderFns } from "./TheTextArea.vue?vue&type=template&id=8b315980&scoped=true"
import script from "./TheTextArea.vue?vue&type=script&lang=js"
export * from "./TheTextArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b315980",
  null
  
)

export default component.exports